export type Navigator = {
  usb?: any;
};

/**
 * wrapper for window.navigator to make it easier replaceable in unit tests
 */
export const NavigatorProvider = {
  provide: 'navigator',
  // eslint-disable-next-line angular/window-service
  useFactory: () => window.navigator,
};
